<template>
  <div class="_content" v-if="(hideKey = true)">
    <!-- <form id="myform" action="" οnsubmit="return false;">
			<input
				id="code-search-input"
				placeholder="请输入券码"
				v-model="code"
				autofocus
				@keyup.enter="handleVerify($event)"
				type="number" 
			/>
		</form> -->
    <div>
      <div class="input-t">
        <van-field
          class="input-text"
          clickable
          v-model="inputValue"
          @touchstart.native.stop="show = true"
          placeholder="请输入小鲲车服消费码"
          :clearable="true"
        />
        <div :class="isQuery ? 'input-btn' : 'input-btn-gray'" @click="getVerifactionConfig">查询</div>
      </div>
      <div class="veri-box" v-if="showSureOff && verifyConfig && verifyConfig.serverName">
        <p class="service-text">服务名称：{{ verifyConfig.serverName }}</p>
        <p class="car-text" v-if="verifyCarNo && isCheckCarNo === '1'">车牌号：{{ verifyCarNo }}</p>
        <p class="car-text" v-if="verifyConfig.vinNo && isCheckCarNo === '1'">
          车架号：{{ verifyConfig.vinNo }}
          <span style="font-size: 0.5rem;">{{
            verifyCarNo ? '（两者不一致优先以车架号为准）' : '（请按照车架号核销）'
          }}</span>
        </p>
        <div class="veri-text" v-if="verifyConfig.verificationDesc">
          <span>注意事项：</span>
          <p class="ql-editor" v-html="verifyConfig.verificationDesc"></p>
        </div>
      </div>
      <div v-if="showSureOff && verifyConfig && verifyConfig.serverName" class="btn" @click="checkCoupon">
        <tt-button text="确认核销" />
      </div>
      <!-- <div class="input-t" @click.stop="show = !show">
				{{inputValue}}
			</div> -->
      <!-- <van-number-keyboard
				:show="show"
				v-model="inputValue"
				theme="custom"
				extra-key="."
				close-button-text="验证"
				:hide-on-click-outside="false"
				@blur="onBlur"
				@input="onInput"
				@delete="onDelete"
				maxlength="12"
			/> -->
    </div>
    <div class="provinces" v-if="showAllProv" ref="provinces">
      <div class="prolist">
        <div
          v-for="(item, index) in provinces"
          :key="index"
          :class="province === item ? 'selected' : ''"
          @click="chooseProvince(item)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <platen
      :showNoBoard="showNoBoard"
      @closeCarNO="showNoBoard = false"
      :chooseCarNO="chooseCarNO"
      :delect="delect"
      :province="province"
      :selectCarNo="carNO"
    >
    </platen>
    <div class="car-no-fill" v-if="showCarNoFill">
      <div class="check-title">核销服务：{{ this.severName }}</div>
      <div class="car-no-cont">
        <div
          class="col-province"
          @click="
            showAllProv = true
            showNoBoard = false
          "
        >
          {{ province }}
        </div>
        <div
          class="col-carNoFill"
          @click="
            showNoBoard = true
            showAllProv = false
          "
        >
          <span class="carno" v-if="carNO">{{ carNO }}</span>
          <span v-else class="carno">请输入车牌号</span>
          <span class="cursor" v-show="!showAllProv && showNoBoard"></span>
        </div>
      </div>
      <div class="sure-btn" @click="sureToOff">确认核销</div>
    </div>
  </div>
</template>

<script>
import ttButton from '@/components/ttButton'
import platen from '@/components/platen'
import config from '@/configs/config'

const carParams = {
  province: '沪',
  provinces: [
    '京',
    '沪',
    '浙',
    '苏',
    '粤',
    '鲁',
    '晋',
    '冀',
    '豫',
    '川',
    '渝',
    '辽',
    '吉',
    '黑',
    '皖',
    '鄂',
    '湘',
    '赣',
    '闽',
    '陕',
    '甘',
    '宁',
    '蒙',
    '津',
    '贵',
    '云',
    '桂',
    '琼',
    '青',
    '新',
    '藏',
    '港',
    '澳'
  ],
  carNO: '',
  showNoBoard: false,
  showAllProv: false,
  showCarNoFill: false
}

export default {
  components: {
    ttButton,
    platen
  },
  data() {
    return {
      isQuery: false,
      showSureOff: false,
      isCheckCarNo: null,
      orderId: 0,
      verifyConfig: {},
      code: '',
      lock: false,
      ...carParams,
      message: '',
      severName: '',
      inputShow: false,
      inputValue: '',
      show: true,
      hideKey: true
    }
  },
  created() {
    this.autoVerifyCode()
  },
  mounted() {
    // let that = this
    // $('#code-search-input').bind('search', function () {
    // 	this.checkCoupon()
    // })
  },
  watch: {
    inputValue(val, newVal) {
      if (val.length < 10) {
        this.isQuery = false
      } else {
        this.isQuery = true
      }
    }
  },
  computed: {
    verifyCarNo() {
      const carNo = this.verifyConfig ? this.verifyConfig.carNo : ''
      const rightCarNo = carNo ? carNo.trim().replace(/[\s\.,\!@#%&*()~`]*/g, '') : ''
      const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{1}[A-HJ-NP-Z]{1}(([A-HJ-NP-Z0-9]{5})|([0-9]{6}|[A-HJ-NP-Z]{1}[0-9]{5}|[0-9]{5}[A-HJ-NP-Z]{1}|[A-HJ-NP-Z]{2}[0-9]{4}))$/
      if (!reg.test(rightCarNo)) {
        return ''
      } else {
        return rightCarNo
      }
    },
    shopId() {
      const shopInfo = tuhu.store.state.currentShopInfo
      return shopInfo ? shopInfo.shopId : tuhu.getParam('shopId')
    }
  },
  methods: {
    async getVerifactionConfig() {
      if (this.inputValue.length < 10) return
      try {
        tuhu
          .fetch(`${config.apis.GET_VERIFICATION_CONFIG}`, {
            method: 'post',
            body: JSON.stringify({
              verificationCode: this.inputValue,
              shopId: parseInt(this.shopId)
            })
          })
          .then(data => {
            if (data && data.code === '200') {
              this.verifyConfig = data.data ? data.data : {}
              if (!this.verifyConfig.serverName) return tuhu.toast('请核实券码是否正确')
              else this.showSureOff = true
              const serviceAttributeInfo = data.data ? JSON.parse(data.data.serviceAttributeInfo) : null
              this.isCheckCarNo = serviceAttributeInfo ? serviceAttributeInfo.isCheckCarNo : null
            } else {
              this.verifyConfig = {}
              this.showSureOff = false
              tuhu.toast( data.message || '请核实券码是否正确')
            }
          })
      } catch (e) {
        console.log(e)
      }
    },
    autoVerifyCode() {
      if (tuhu.getParam('success')) {
        this.inputValue = (this.options && this.options.verifyCode) || ''
        // this.onBlur()
      } else {
      }
    },
    async checkCoupon() {
      if (this.lock) return false

      if (this.inputValue.length < 10) return tuhu.toast('请输入正确的小鲲消费码')

      this.lock = true

      this.$kun.showLoading('正在核销，请不要关闭页面，耐心等待')
      setTimeout(() => {
        this.lock = false
      }, 2500)

      try {
        // 给接口添加 30秒 超时控制
        const timeoutPromise = new Promise((resolve, reject) => {
          setTimeout(() => {
            reject(new Error('timeout'))
          }, 30000) // 30秒超时
        })

        // 竞赛模式：接口请求 vs 超时，谁先完成执行谁
        const data = await Promise.race([
          tuhu.fetch(`${config.apis.CHECK_CODE_COUPON}?code=${this.inputValue}&shopId=${this.shopId}`),
          timeoutPromise
        ])
        if (data && data.code === '200') {
          // this.severName = data.data

          let res = data.data
          this.$kun.hideLoading()
          if (res.isUploadPhoto) return this.uploadImg(res)
          else return this.sureToOff(res)
        } else {
          this.$kun.hideLoading()

          tuhu.toast(data.message || '网络错误')

          console.log(data.message)
        }
      } catch (e) {
        // 判断是否是超时错误
        if (e.message === 'timeout') {
          this.$kun.hideLoading()
          tuhu.toast('核销失败，请重试')
        } else {
          this.$kun.hideLoading()
          tuhu.toast('核销失败，请检查网络后重试')
        }
        console.log(e)
      }
    },
    chooseProvince(item) {
      this.province = item
      this.showAllProv = false
      this.showNoBoard = true
    },
    chooseCarNO(no) {
      this.carNO = no
    },
    delect() {
      this.carNO = this.carNO.slice(0, -1)
    },
    // 不输入车牌核销
    async sureToOff(obj) {
      this.$kun.showLoading('正在核销，请不要关闭页面，耐心等待')

      try {
        const data = await tuhu.fetch(`${config.apis.GET_CODE_COUPON}`, {
          method: 'post',
          body: JSON.stringify({
            shopId: this.shopId,
            carNo: '',
            code: (obj && obj.writeOffCode)||this.inputValue
          })
        })

        this.showCarNoFill = false

        this.showAllProv = false

        if (data && data.code === '200') {
          this.$kun.hideLoading()

          tuhu.toast('核销成功')

          setTimeout(() => {
            this.showAllProv = false

            this.code = ''

            let info = Object.assign(data.data, {
              Message: data.message
            })

            tuhu.sessionStorage.setItem('shopOrderDetail', JSON.stringify(info))

            tuhu.navigateTo({
              url: '/pages/orderDetail/index',

              data: {
                ListInfo: info
              },

              query: {
                success: data.code === '200' ? 1 : ''
              }
            })
          }, 300)
        } else {
          this.$kun.hideLoading()

          tuhu.toast(data.message || '网络错误')
        }
      } catch (e) {
        this.$kun.hideLoading()

        console.log(e)
      }
    },
    uploadImg(data) {
      tuhu.sessionStorage.setItem('upDetail', JSON.stringify(data))
      tuhu.navigateTo({
        url: '/pages/verifyUploadImg/index',
        data: {
          uploadDetail: data
        },
        query: {
          isCheckCarNo: this.isCheckCarNo,
          carNo: this.verifyConfig.carNo,
          sId: this.shopId,
          vCode: (data && data.writeOffCode)||this.inputValue
        }
      })
    },
    onBlur() {
      this.show = false
      this.checkCoupon()
    },
    onInput() {},
    onDelete() {},
    onPageBack(to, from) {
      if (from.path.indexOf('/pages/orderDetail') > -1) {
        this.inputValue = ''
      }
    }
  }
}
</script>
<style scoped lang="less">
@import '../../css/provinceInput.css';

.car-no-fill {
  width: 80%;
  position: fixed;
  top: 5rem;
  left: 10%;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  padding: 0.75rem;
  z-index: 10001;

  .check-title {
    width: 100%;
    height: 3rem;
    line-height: 3rem;
    font-size: 18px;
    text-align: center;
  }

  .car-no-cont {
    display: flex;
    align-items: center;
  }

  .sure-btn {
    width: 80%;
    height: 2.2rem;
    line-height: 2.2rem;
    background: #1989fa;
    color: #fff;
    margin: 0 auto;
    margin-top: 1rem;
    border-radius: 5px;
    text-align: center;
    font-size: 18px;
  }

  .col-province {
    width: 3rem;
    height: 1.8rem;
    line-height: 1.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #006eef;
    padding: 2px 0.8rem 2px 3px;
    color: #fff;
    font-size: 20px;

    &::after {
      position: absolute;
      content: '';
      width: 1rem;
      height: 1rem;
      background: url(../../imgs/image/arrow-dowm.png) no-repeat;
      background-size: 100%;
      right: 2px;
      top: 5px;
    }
  }

  .col-carNoFill {
    height: 2.2rem;
    line-height: 2.2rem;
    text-align: right;
    padding: 0 5px;
    position: relative;
    flex: 1;
    text-align: left;
    margin-left: 0.5rem;

    .carno {
      color: #999;
      font-size: 20px;
    }

    .cursor {
      width: 0;
      height: 20px;
      vertical-align: middle;
      border: 1px solid black;
      padding: 0 !important;
      // display: none;
      animation: cursorBlink 0.8s infinite;
      position: absolute;
      top: 50%;
      margin-top: -9px;
      display: inline-block;
      margin-left: 0.5rem;
    }

    @keyframes cursorBlink {
      0% {
        opacity: 0;
      }

      70% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
  }
}
</style>
<style lang="less" scoped>
._content {
  padding: 0.75rem;
  background: #fff;

  .veri-box {
    padding: 0.25rem 0.75rem 0.95rem;
    margin-top: 1rem;
    min-height: 2rem;
    width: 100%;
    background: #ffffff;
    border-radius: 0.75rem;
    border: 0.05rem solid #e9e9e9;

    .service-text {
      font-weight: 600;
      font-size: 0.7rem;
      color: #125cf7;
      line-height: 1.6rem;
      text-align: left;
    }

    .car-text {
      font-weight: 600;
      font-size: 0.7rem;
      color: rgba(255, 66, 0, 1);
      line-height: 1.6rem;
      text-align: left;
    }

    .veri-text {
      display: inline;
      margin-top: 0.75rem;

      span {
        font-weight: 600;
        font-size: 0.7rem;
        color: #ff0000;
        line-height: 1.25rem;
        text-align: left;
      }
    }
  }

  .tip-dialog {
    width: 85%;

    :deep(.van-dialog__header) {
      font-weight: 600;
    }

    .text {
      margin: 1.2rem auto;
      font-size: 0.7rem;
      color: #333333;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .input-t {
    display: flex;
    align-self: flex-end;

    .input-text {
      width: calc(100% - 3.4rem);
      height: 2.2rem;
      background: #ffffff;
      border-radius: 1.16rem;
      border: 0.05rem solid #e9e9e9;
    }

    .input-btn {
      height: 2rem;
      line-height: 2rem;
      background: #1989fa;
      color: #fff;
      margin: 0.1rem 0.2rem;
      border-radius: 0.8rem;
      text-align: center;
      font-size: 0.8rem;
      width: 3rem;
    }

    .input-btn-gray {
      touch-action: none;
      height: 2rem;
      line-height: 2rem;
      background: #b2b2b2;
      color: #fff;
      margin: 0.1rem 0.2rem;
      border-radius: 0.8rem;
      text-align: center;
      font-size: 0.8rem;
      width: 3rem;
    }
  }

  .btn {
    width: 100%;
    height: 2.4rem;
    margin-top: 1rem;
  }

  input {
    width: 100%;
    height: 3rem;
    line-height: 3rem;
    padding-left: 0.5rem;
    border: 1px solid #dfdfdf;
    border-radius: 5px;
  }
}

.check-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/pages/verifyCode/index.vue